




import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getCookie, getImgURLOfBase64, getChaos } from '@/utils/fix'
import { getToken } from '@/api/common'
@Component({
  name: 'form-title'
})
export default class extends Vue {
  @Prop({ required: true }) private src!: string // 绑定的图片地址
  private trueSrc: string = require('@/assets/images/loading.svg')
  private throte: boolean = false
  private loaded: string = ''

  async loadImage() {
    let img: any = this.$refs.img
    if (this['loaded']) return
    await getChaos()
    let header = {
      abc: getCookie('abc')
    }
    try {
      let src = await getImgURLOfBase64(this['src'], header)
      img.src = src
      this['loaded'] = 'loaded'
      return src
    } catch (err) {
      console.log(err)
      this['loaded'] = 'loaded'
    }
    this.loaded = 'loaded' // 给与加载完毕的图片一个标识, 防止重复请求接口
  }
  @Watch('src')
  async srcChange(newVal: string, oldVal: string) {
    this.trueSrc = require('@/assets/images/loading.svg')
    this.loaded = ''
    await this.loadImage()
  }
}
